import {
  Body,
  Column,
  Head,
  Html,
  Img,
  Link,
  Row,
  Section,
  Text,
} from "@react-email/components";
import { Email as Styles } from "themes/styles";
import { Helpers } from "utils";
import { StepConfig } from "assets/data";

// components
import { Footer } from "./components/Footer";

export type Props = {
  url: string;
  name: string;
};

export const SignUp = ({ url, name }: Props) => {
  const steps = StepConfig;

  return (
    <Html lang="en">
      <Head />
      <Body style={Styles.body}>
        <Img style={Styles.img} src={Helpers.getImage("email_sign_up.png")} />
        <div style={Styles.content}>
          {/* header */}
          <Text style={Styles.textBold}>Hello {name},</Text>

          {/* paragraph */}
          <Text style={Styles.textBold}>
            Thank you for signing up! We are pleased to have you on board. Start
            Potluck'IN and build your own foodie community!
          </Text>

          {/* paragraph */}
          <Text style={Styles.text}>
            With Potluck'IN, creating your food profile is just the
            beginning—connect with like-minded food lovers in your community or
            effortlessly host your own potluck and build a community of your
            own!
          </Text>

          {/* steps */}
          <Section>
            {StepConfig.map((step, index) => (
              <Row key={index} style={Styles.row}>
                <Column style={Styles.column}>
                  <Img style={Styles.thumb} src={Helpers.getImage(step.src)} />
                </Column>
                <Column style={Styles.column}>
                  <Text style={Styles.text}>{step.description}</Text>
                </Column>
              </Row>
            ))}
          </Section>

          {/* button */}
          <Link href={url} style={Styles.button}>
            Start Potluck'IN!
          </Link>
        </div>
        <Footer />
      </Body>
    </Html>
  );
};
